// Menu Mobile: abrir/fechar sem clonar conteúdo (sem jQuery)
(function() {
    'use strict';

    let initialized = false;

    function onDoc(evt, selector, handler) {
        document.addEventListener(evt, function(e) {
            const target = e.target.closest(selector);
            if (target) handler(e, target);
        });
    }

    function openMenu(e) {
        e.preventDefault();
        e.stopPropagation();
        document.body.classList.add('menu_open');
    }

    function closeMenu(e) {
        e.preventDefault();
        e.stopPropagation();
        document.body.classList.remove('menu_open');
    }

    function init() {
        if (initialized) return;

        onDoc('click', '.mobileMenu-toggle, [data-mobile-menu]', openMenu);
        onDoc('click', '.halo-sidebar-close, .background-overlay', closeMenu);
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && document.body.classList.contains('menu_open')) {
                document.body.classList.remove('menu_open');
            }
        });

        initialized = true;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.menuSidebarMobile = init;
})();